import { render, staticRenderFns } from "./BaseTextButton.vue?vue&type=template&id=1f02c6b9&scoped=true"
import script from "./BaseTextButton.vue?vue&type=script&lang=js"
export * from "./BaseTextButton.vue?vue&type=script&lang=js"
import style0 from "./BaseTextButton.vue?vue&type=style&index=0&id=1f02c6b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f02c6b9",
  null
  
)

export default component.exports